import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AddEmployee from './AddEmployee'
import { CircularProgress, Box, Typography, Button } from '@mui/material'
import { useLoading } from '../../hooks'
import { employeeApi } from '../../api/employeeApi'

const EditEmployee = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [employeeData, setEmployeeData] = useState(null)
  const { loading, startLoading, stopLoading } = useLoading(true)

  useEffect(() => {
    const fetchEmployeeData = async () => {
      if (!id) return;

      try {
        startLoading()
        const response = await employeeApi.getEmployeeDetails(id)
        const data = response.data

        // Parse working_days if needed
        let parsedWorkingDays = []
        try {
          if (typeof data.working_days === 'string') {
            parsedWorkingDays = JSON.parse(data.working_days)
          } else if (Array.isArray(data.working_days)) {
            parsedWorkingDays = data.working_days
          }
        } catch (e) {
          console.error('Error parsing working days', e)
        }

        const mappedData = {
          id: data.employee_id,
          firstName: data.first_name,
          lastName: data.last_name,
          email: data.email,
          phone: data.phone,
          department: data.department,
          position: data.designation,
          joinDate: data.join_date,
          salary: data.salary,
          address: data.address,
          emergencyContact: data.emergency_contact,
          emergencyPhone: data.emergency_phone,
          bloodGroup: data.blood_group,
          maritalStatus: data.marital_status,
          gender: data.gender || '',
          status: data.status,
          faceEnrolled: data.faceEnrolled,
          employeeType: data.employee_type,
          workShift: data.work_shift_id || data.work_shift,
          workingDays: parsedWorkingDays.length ? parsedWorkingDays : ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          photo: data.photo,
          notes: data.notes // Assuming notes might be in response or ignored if not present
        }

        setEmployeeData(mappedData)
      } catch (error) {
        console.error('Failed to fetch employee data:', error)
      } finally {
        stopLoading()
      }
    }

    fetchEmployeeData()
  }, [id])

  const handleCancel = () => {
    navigate('/org/employees')
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (!employeeData) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Employee not found
        </Typography>
        <Button onClick={() => navigate('/org/employees')} sx={{ mt: 2 }}>
          Back to Employees
        </Button>
      </Box>
    )
  }

  return (
    <AddEmployee
      initialData={employeeData}
      mode="edit"
      onCancel={handleCancel}
    />
  )
}

export default EditEmployee